import '../utilities/tilt.min.js'; // https://github.com/gijsroge/tilt.js

$ = window.jQuery;

const s = {
  cards: $('.m-rate-card'),
}

function init() {
  if (s.cards.length > 0) {
    s.cards.tilt({
      scale: 1.01,
      glare: true,
      maxGlare: .5,
      maxTilt: 10,
      perspective: 1500
    })
  }
}

export { init as default }
